import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.integrations.Connector.Input,
    graphql.schema.IntgConnectorInput
  >({
    baseUrl: transformers.PASS_THROUGH,
    definitionId: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    Partial<ents.core.integrations.Connector.Input>,
    graphql.schema.IntgConnectorUpdates
  >({
    baseUrl: transformers.PASS_THROUGH,
    definitionId: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
  }),
)
